<ion-header>
  <ion-toolbar mode="md"
               color="dark">
    <ion-buttons slot="start">
      <ion-button mode="md"
                  debounce-click
                  [debounceTime]="0"
                  (debounceClick)="onCloseModal(true)"
                  color="orange"
                  fill="solid"> {{ 'donation.noDontRoundUp' | transloco }} </ion-button>
    </ion-buttons>
    <ion-title>{{ 'donation.roundUpForCharity' | transloco }}</ion-title>
    <ion-buttons slot="end">
      <ion-button mode="md"
                  debounce-click
                  [debounceTime]="0"
                  (debounceClick)="onCloseModal()">{{ 'common.close' | transloco }}</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content fullscreen>
  <div *ngIf="!isCustomAmount">
    <p>{{ 'donation.wouldGuestLikeToRoundUp' | transloco }}</p>
    <p [innerHTML]="'donation.conversationPrompt' | transloco: { charityName: (menuItem | translatedName: currentLang) }"></p>
    <ion-row class="information">
      <ion-col size="12"
               class="ion-no-padding suggested-amount">
        <p class="text-overflow">{{ 'donation.suggestedAmount' | transloco }}</p>
      </ion-col>
      <ion-col size="12"
               class="ion-no-padding round-up-amount">
        <img src="assets/icon/icon-charity.png"
             class="icon" />
        <p class="text-overflow">{{ suggestedAmount | currency }}</p>
      </ion-col>
      <ion-col size="12"
               class="ion-no-padding">
        <p class="text-overflow">{{ 'donation.updatedOrderTotal' | transloco }} <strong>{{ totalAmount | currency }}</strong></p>
      </ion-col>
    </ion-row>
  </div>
  <div *ngIf="isCustomAmount">
    <p>{{ 'donation.enterCustomAmountInstead' | transloco }}</p>
    <pos-numeric-keyboard (onValueChange)="onNumericKeyboardInput($event)"
                          [value]="amount"
                          [buttons]="[]"></pos-numeric-keyboard>
  </div>
</ion-content>
<ion-footer>
  <ion-toolbar *ngIf="!isCustomAmount"
               mode="md"
               color="light">
    <ion-buttons slot="start">
      <ion-button mode="md"
                  color="dark"
                  fill="solid"
                  debounce-click
                  [debounceTime]="0"
                  (debounceClick)="customAmount()"> {{ 'donation.enterCustomAmount' | transloco }} </ion-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button mode="md"
                  color="dark"
                  fill="solid"
                  debounce-click
                  [debounceTime]="0"
                  (debounceClick)="addCharityProduct()"> {{ 'donation.yesRoundUp' | transloco }} </ion-button>
    </ion-buttons>
  </ion-toolbar>
  <ion-toolbar *ngIf="isCustomAmount"
               mode="md"
               color="light">
    <ion-buttons slot="end">
      <ion-button mode="md"
                  color="dark"
                  fill="solid"
                  debounce-click
                  [debounceTime]="0"
                  (debounceClick)="saveAmount()"> {{ 'donation.saveAmount' | transloco }}</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
